import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { WorkId } from 'js/liswp/types';

const DISMISSAL_API = routes.record_ping_dismissal_api_v0_onsite_pings_path({
  subdomain_param: 'api',
});

export const recordDismissal = (pingName: string) =>
  fetchWithCsrf(DISMISSAL_API, {
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ping_name: pingName }),
    method: 'POST',
  });

export const getCheckoutUrl = (
  workId: WorkId,
  feature: string,
  trigger: string,
): string => {
  const upgradeRedirect = encodeURIComponent(
    routes.show_work_url({
      bulkDownload: true,
      id: workId,
    }),
  );

  return routes.checkout_url({ feature, trigger, upgradeRedirect });
};
